export default class Location {
  constructor(locationElement) {
    const { id, maxCapacity, venueType, venueCapacities, active } = locationElement.dataset;

    this.id = id;
    this.maxCapacity = parseInt(maxCapacity, 10) || 0;
    this.venueType = venueType ? JSON.parse(venueType) : [];
    this.venueCapacities = venueCapacities && venueCapacities != "false" ? JSON.parse(venueCapacities) : [];
    this.active = active === "true";
  }

  isActiveLocation(activeTypeValue, minimumCapacity, selectedLineup) {
    if (!activeTypeValue) return false;

    return (
      this.isLocationOfActiveType(activeTypeValue) &&
      this.isMinimumCapacityMet(minimumCapacity) &&
      this.isMinimumCapacityForSelectedLayoutMet(selectedLineup, minimumCapacity)
    );
  }

  isLocationOfActiveType(activeTypeValue) {
    return this.venueType.includes(activeTypeValue);
  }

  isMinimumCapacityMet(minCapacity) {
    return this.maxCapacity >= minCapacity;
  }

  isMinimumCapacityForSelectedLayoutMet(selectedLineup, minCapacity) {
    if (!selectedLineup) return true;
    const selectedVenue = this.getSelectedVenueCapacity(selectedLineup);
    if (!selectedVenue) return false;
    return parseInt(selectedVenue["venue-layout-capacity"], 10) >= minCapacity;
  }

  getSelectedVenueCapacity(selectedLineup) {
    return this.venueCapacities.find(
      (venueCapacity) => venueCapacity["venue-layout"] === selectedLineup
    );
  }
}
